import { resolveHelpSiteUrl } from '@/config/app';

/** Locale-aware URL into the help site. The help site's locale slugs are
 *  lowercase ('zh-tw'), unlike the app's i18n codes ('zh-TW'); English is
 *  the root locale and any unknown language falls back to it. The origin is
 *  env-dependent (dev/staging/production help site) — injectable for tests. */
export function helpUrlForLanguage(
    language: string,
    baseUrl: string = resolveHelpSiteUrl(),
): string {
    if (language === 'zh-TW') return `${baseUrl}/zh-tw/`;
    if (language === 'ja') return `${baseUrl}/ja/`;
    return `${baseUrl}/`;
}
